import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {TableService} from '../../services/table.service';
import {CompanyService} from '../../generated/api/company.service';
import {UserLoggedRolesServiceService} from '../../authenticationModule/services/user-logged-roles-service.service';
import {ConfirmationService, Message, SelectItem, SortEvent} from 'primeng/api';
import * as _ from 'lodash';
import {Column} from '../../share/models/column';
import {CompanyLabel} from '../../Enum/company-label.enum';
import {CustomCompanyService} from '../../services/custom-company.service';
import {CustomUserService} from '../../services/custom-user.service';
import {ClientSearchCriteria} from '../../models/filter/client-search-criteria';
import {environment} from '../../../environments/environment';
import {saveAs} from 'file-saver';
import {Company} from '../../models/company';
import {BaseClientComponent} from '../base-client.component';
import {Table} from 'primeng/table';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'app-list-clients',
  templateUrl: './list-clients.component.html',
  styleUrls: ['./list-clients.component.scss']
})
export class ListClientsComponent extends BaseClientComponent implements OnInit {
  listClients: Company[];
  filteredListClients: Company[];
  clientSearchCriteria: ClientSearchCriteria;
  cols: Column[];
  loading = false;
  error = false;
  statusItem: SelectItem[];
  billingAccounts: string;
  successActivateCompany = false;
  successDeactivateCompany = false;
  successDownloadUsersCsv = false;
  msgsAws: Message[] = [];
  errorMessage: string;
  syncError = false;
  successSync = false;
  @ViewChild(Table) table: Table;
  userChoicesFiltersDefaultClients = {
    Name: '',
    UserName: '',
    BillingAccount: '',
    Status: 'active',
    CanSeeGraphMckay: true,
    CanSeeGraphQuincy: true,
    CanSeeGraphVendor: true,
    ActiveDadReport: false,
    DadIce: false,
    DadEurex: false,
    DadEuronext: false,
    DadLme: false,
    DadLse: false,
    DadTurq: false
  };
  userChoicesActiveFilters = _.clone(this.userChoicesFiltersDefaultClients);
  syncIsDisabled: boolean;
  syncIsRunning: boolean;
  automaticSync: boolean;
  syncButtonDisabled: boolean;
  maxVisibleBillingAccounts = 2;
  private expandedBillingAccounts: string[] = [];

  constructor(private authenticationService: AuthenticationService,
              private _route: ActivatedRoute,
              private confirmationService: ConfirmationService,
              private _router: Router,
              private http: HttpClient,
              public tableService: TableService,
              public roleService: UserLoggedRolesServiceService,
              public companyService: CompanyService,
              private utilsService: UtilsService,
              private customCompanyService: CustomCompanyService,
              private customUserService: CustomUserService) {
    super();
    this.cols = [
      {field: 'name', header: 'Name', type: 'string', sortable: true, width: 'name-width'},
      {field: 'billingAccounts', header: 'Billing accounts', type: 'string', sortable: false, width: 'name-width'},
      {field: 'sugarMckayStatus', header: 'Mckay status', type: 'string', sortable: false, width: 'status-width'},
      {field: 'sugarQuincyStatus', header: 'Quincy status', type: 'string', sortable: false, width: 'status-width'},
      {field: 'ndaDates', header: 'NDA Dates', type: 'date', sortable: true, width: 'other-width', sortField: 'ndaExecutionDate'},
      {field: 'createdAt', header: 'Created date', type: 'date', sortable: true, width: 'other-width'},
      {field: 'lastLogin', header: 'Last login', type: 'date', sortable: true, width: 'other-width'},
      {field: 'admin', header: 'Admin', type: 'string', sortable: false, width: 'admin-action-width'},
      {field: 'actions', header: 'Actions', type: 'string', sortable: false, width: 'action-width'},
      {field: 'profile', header: 'Profile', type: 'string', sortable: false, width: 'action-width'}
    ];

    this.statusItem = [
      {label: 'Active', value: 'active'},
      {label: 'Inactive', value: 'inactive'},
      {label: 'All', value: 'all'},
    ];
  }

  ngOnInit() {
    this.loading = true;
    this.userChoicesActiveFilters = this.utilsService.loadUserPref('clientsFilter', this.userChoicesFiltersDefaultClients);
    this.clientSearchCriteria = new ClientSearchCriteria(this.userChoicesActiveFilters);
    this._route.paramMap.subscribe(params => {
      const currentCompanyUniqId = params.get('currentCompanyUniqId');
      if (currentCompanyUniqId !== this.getUserCurrent().company.uniqid) {
        this.redirectionToNotFound();
      }
    });
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.loadListClients();
    });
    this.subscriptions.push(response$);

  }
  customSort(event: SortEvent) {
    const column = this.cols.find(c => c.field === event.field);
    const field = column?.sortField || event.field;
    event.data.sort((current, next) => {
      const currentValue = current[field] || null;
      const nextValue = next[field] || null;
      if (currentValue == null && nextValue == null) { return 0; }
      if (currentValue == null) { return -1 * event.order; }
      if (nextValue == null) { return event.order; }
      let result: number;
      if (column?.type === 'date') {
        result = this.compareDates(currentValue, nextValue);
      } else if (typeof currentValue === 'string' && typeof nextValue === 'string') {
        result = currentValue.localeCompare(nextValue, undefined, {sensitivity: 'base'});
      } else {
        result = currentValue < nextValue ? -1 : currentValue > nextValue ? 1 : 0;
      }
      return event.order * result;
    });
  }

  private compareDates(current: any, next: any): number {
    const currentDate = new Date(current).getTime();
    const nextDate = new Date(next).getTime();
    if (isNaN(currentDate) && isNaN(nextDate)) { return 0; }
    if (isNaN(currentDate)) { return -1; }
    if (isNaN(nextDate)) { return 1; }
    return currentDate - nextDate;
  }

  redirectionToNotFound() {
    this.utilsService.redirectToNotFound();
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  filter() {
    this.filteredListClients = [];
    this.utilsService.saveUserData('clientsFilter',
      {
        Name: this.clientSearchCriteria.nameOrShortnameOrBillingAccount,
        UserName: this.clientSearchCriteria.userNameOrEmail,
        Status: this.clientSearchCriteria.status,
        CanSeeGraphMckay: this.clientSearchCriteria.canSeeGraphMckay,
        CanSeeGraphQuincy: this.clientSearchCriteria.canSeeGraphQuincy,
        CanSeeGraphVendor: this.clientSearchCriteria.canSeeGraphVendor,
        ActiveDadReport: this.clientSearchCriteria.activeDadReport,
        DadIce: this.clientSearchCriteria.dadIce,
        DadEurex: this.clientSearchCriteria.dadEurex,
        DadEuronext: this.clientSearchCriteria.dadEuronext,
        DadLme: this.clientSearchCriteria.dadLme,
        DadLse: this.clientSearchCriteria.dadLse,
        DadTurq: this.clientSearchCriteria.dadTurq
      });
    for (const client of this.listClients) {
      if (this.filterClients(client)) {
        this.filteredListClients.push(client);
      }
    }
    if (this.table) {
      this.table.reset();
    }
  }

  filterClients(client): boolean {
    return this.getUserCurrent().company.uniqid !== client.uniqid
      && this.hasNameOrShortnameOrBillingAccount(client)
      && this.hasUsernameOrEmail(client)
      && this.isActive(client)
      && this.canSeeGraph(client)
      && this.hasActiveDadReport(client)
      && this.hasDad(client);
  }

  resetTable(): void {
    this.utilsService.saveUserData('clientsFilter',
      this.userChoicesFiltersDefaultClients);
    this.clientSearchCriteria = new ClientSearchCriteria(this.userChoicesFiltersDefaultClients);
    this.filter();
  }

  hasNameOrShortnameOrBillingAccount(client: Company): boolean {
    return this.clientSearchCriteria.nameOrShortnameOrBillingAccount === ''
      || (client.name && client.name.toLowerCase().includes(this.clientSearchCriteria.nameOrShortnameOrBillingAccount.toLowerCase()))
      || (client.sugarShortname && client.sugarShortname.toLowerCase().includes(this.clientSearchCriteria.nameOrShortnameOrBillingAccount.toLowerCase()))
      || client.distinctBillingAccounts.join(', ').toLowerCase().includes(this.clientSearchCriteria.nameOrShortnameOrBillingAccount.toLowerCase());
  }

  hasUsernameOrEmail(client: Company): boolean {
    if (this.clientSearchCriteria.userNameOrEmail === '' || !client.usersInfos) {
      return true;
    }
    for (const user of client.usersInfos) {
      if (user.name.toLowerCase().includes(this.clientSearchCriteria.userNameOrEmail.toLowerCase())
        || user.email.toLowerCase().includes(this.clientSearchCriteria.userNameOrEmail.toLowerCase())) {
        return true;
      }
    }
    return false;
  }

  isActive(client): boolean {
    if (this.clientSearchCriteria.status === 'active') {
      return client.isActive;
    }
    if (this.clientSearchCriteria.status === 'inactive') {
      return !client.isActive;
    }
    return this.clientSearchCriteria.status === 'all';
  }

  canSeeGraph(client: Company) {
    if (this.clientSearchCriteria.canSeeGraphMckay) {
      if (!this.clientSearchCriteria.canSeeGraphQuincy) {
        if (this.clientSearchCriteria.canSeeGraphVendor) {
          return client.label === CompanyLabel.LABEL_MCKAY || client.label === CompanyLabel.LABEL_ALL
            || client.label === CompanyLabel.LABEL_VENDOR;
        } else {
          return client.label === CompanyLabel.LABEL_MCKAY || client.label === CompanyLabel.LABEL_ALL;
        }
      } else {
        if (!this.clientSearchCriteria.canSeeGraphVendor) {
          return client.label === CompanyLabel.LABEL_MCKAY || client.label === CompanyLabel.LABEL_QUINCY
            || client.label === CompanyLabel.LABEL_ALL;
        } else {
          return client.label === CompanyLabel.LABEL_MCKAY || client.label === CompanyLabel.LABEL_QUINCY
            || client.label === CompanyLabel.LABEL_ALL || client.label === CompanyLabel.LABEL_VENDOR;
        }
      }
    } else {
      if (!this.clientSearchCriteria.canSeeGraphQuincy) {
        if (this.clientSearchCriteria.canSeeGraphVendor) {
          return client.label === CompanyLabel.LABEL_VENDOR;
        } else {
          return false;
        }
      } else {
        if (!this.clientSearchCriteria.canSeeGraphVendor) {
          return client.label === CompanyLabel.LABEL_QUINCY || client.label === CompanyLabel.LABEL_ALL;
        } else {
          return client.label === CompanyLabel.LABEL_QUINCY || client.label === CompanyLabel.LABEL_ALL
            || client.label === CompanyLabel.LABEL_VENDOR;
        }
      }
    }
  }

  hasActiveDadReport(client: Company): boolean {
    return !this.clientSearchCriteria.activeDadReport || client.dadInLastMonth;
  }

  hasDad(client: Company): boolean {
    if (!this.clientSearchCriteria.dadIce
      && !this.clientSearchCriteria.dadEurex
      && !this.clientSearchCriteria.dadEuronext
      && !this.clientSearchCriteria.dadLme
      && !this.clientSearchCriteria.dadTurq
      && !this.clientSearchCriteria.dadLse) {
      return true;
    }
    const checkedDad = [];
    if (this.clientSearchCriteria.dadIce) {
      checkedDad.push('ice');
    }
    if (this.clientSearchCriteria.dadEurex) {
      checkedDad.push('eurex');
    }
    if (this.clientSearchCriteria.dadEuronext) {
      checkedDad.push('euronext');
    }
    if (this.clientSearchCriteria.dadLme) {
      checkedDad.push('lme');
    }
    if (this.clientSearchCriteria.dadLse) {
      checkedDad.push('lse');
    }
    if (this.clientSearchCriteria.dadTurq) {
      checkedDad.push('turq');
    }
    if (!client.dadConfigsNames) {
      return false;
    }
    for (const dad of checkedDad) {
      if (client.dadConfigsNames.includes(dad)) {
        return true;
      }
    }
    return false;
  }

  isAdminCompany(client): boolean {
    if (!client) {
      return false;
    }
    return client.uniqid === 'admin';
  }

  navigateToClient(client: any) {
    const url = `/${this.getUserCurrent().company.uniqid}/company/${client.uniqid}/company`;
    this._router.navigate([url]);
  }

  canListUsers(): boolean {
    return this.getUserCurrent().permissions.canListUsers;
  }

  canListLOAs(): boolean {
    return this.roleService.userHasOneOfThoseRoles(this.getUserCurrent(), ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_OPERATIONS', 'ROLE_MCKAY_DEVELOPER']);
  }

  canListDadAdmin(): boolean {
    return this.roleService.userHasOneOfThoseRoles(this.getUserCurrent(), ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_DAD_REPORTER']);
  }

  hasPermissionClientProfile(): boolean {
    return this.roleService.userHasOneOfThoseRoles(this.getUserCurrent(), ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_DEVELOPER', 'ROLE_MCKAY_DAD_REPORTER']);
  }

  canManageInvoiceRecipients(): boolean {
    return this.roleService.userHasOneOfThoseRoles(this.getUserCurrent(), ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_FINANCE']);
  }

  canActivateAWS(): boolean {
    return this.roleService.userHasOneOfThoseRoles(this.getUserCurrent(), ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN']);

  }

  canListSchedules() {
    return this.getUserCurrent().permissions.canListSchedules;
  }

  activateOrDeactivate(client) {
    if (!client) {
      return;
    }
    this.hideSuccessActivateCompany();
    this.hideSuccessDeactivateCompany();
    if (client.isActive) {
      if (confirm(`Are you sure you want to deactivate "${client.name}" ?`)) {
        this.deactivate(client);
      }
    } else {
      if (confirm(`Are you sure you want to activate "${client.name}" ?`)) {
        this.activate(client);
      }
    }
  }

  hideSuccessDeactivateCompany() {
    this.successDeactivateCompany = false;
  }

  hideSuccessActivateCompany() {
    this.successActivateCompany = false;
  }

  hideSuccessDownloadUsersCsv() {
    this.successDownloadUsersCsv = false;
  }

  getBillingAccounts(client: Company) {
    if (!client.distinctBillingAccounts) {
      return [];
    }
    return client.distinctBillingAccounts.sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  getVisibleBillingAccounts(client: Company): string[] {
    const accounts = this.getBillingAccounts(client);
    if (this.isBillingAccountsExpanded(client) || accounts.length <= this.maxVisibleBillingAccounts) {
      return accounts;
    }
    return accounts.slice(0, this.maxVisibleBillingAccounts);
  }

  hasMoreBillingAccounts(client: Company): boolean {
    return this.getBillingAccounts(client).length > this.maxVisibleBillingAccounts;
  }

  isBillingAccountsExpanded(client: Company): boolean {
    return this.expandedBillingAccounts.includes(client.uniqid);
  }

  toggleBillingAccountsExpansion(client: Company, event: Event): void {
    event.stopPropagation();
    if (this.expandedBillingAccounts.includes(client.uniqid)) {
      this.expandedBillingAccounts = this.expandedBillingAccounts.filter(uniqid => uniqid !== client.uniqid);
    } else {
      this.expandedBillingAccounts.push(client.uniqid);
    }
  }

  canAddOrEditClients(): boolean {
    return this.roleService.userHasOneOfThoseRoles(this.getUserCurrent(), ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN']);
  }

  activateOrDeactivateAwsAccess(client: any) {
    if (!client) {
      return;
    }
    if (client.awsPacketCounterAccess) {
      this.confirmationService.confirm({
        message: `Are you sure you want to deactivate AWS access for "${client.name}"?`,
        accept: () => {
          this.deactivateAwsAccess(client);
        }
      });
    } else {
      this.confirmationService.confirm({
        message: `Are you sure you want to activate AWS access for "${client.name}"?`,
        accept: () => {
          this.activateAwsAccess(client);
        }
      });
    }
  }

  // extract the activation and deactivating of the aws access into separated methods to be used apart
  private deactivateAwsAccess(client: any) {
    this.companyService.putCompanyItem(client.id, {
      awsPacketCounterAccess: false,
      awsMqttPortsCountersActivationDate: null
    }).subscribe({
      next: () => {
        client.awsPacketCounterAccess = false;
        this.showAccessRevokedMessage(client);
      },
      error: () => {
        this.showErrorMessage(client, 'revoking');
      }
    });
  }

  private activateAwsAccess(client: any) {
    this.companyService.putCompanyItem(client.id, {awsPacketCounterAccess: true}).subscribe({
      next: () => {
        client.awsPacketCounterAccess = true;
        this.showAccessGrantedMessage(client);
      },
      error: () => {
        this.showErrorMessage(client, 'granting');
      }
    });
  }

  private showAccessRevokedMessage(client: any) {
    this.msgsAws = [];
    this.msgsAws.push({
      severity: 'error',
      summary: 'Access revoked',
      detail: `Access to AWS for "${client.name}" has been revoked.`
    });
  }

  private showAccessGrantedMessage(client: any) {
    this.msgsAws = [];
    this.msgsAws.push({
      severity: 'success',
      summary: 'Access granted',
      detail: `Access to AWS for "${client.name}" has been granted.`
    });
  }

  private showErrorMessage(client: any, action: string) {
    this.msgsAws = [];
    this.msgsAws.push({
      severity: 'error',
      summary: 'Action failed',
      detail: `An error occurred while ${action} AWS access for "${client.name}"`
    });
  }

  exportListUserCSV() {
    this.utilsService.lockUi();
    const clientIds = this.filteredListClients.map(client => client.id);
    const url = environment.baseUrlWs + '/api/export-user-csv-file';
    const requestBody = {
      client_ids: clientIds
    };
    requestBody.client_ids = clientIds;
    this.http.post(url, requestBody, {observe: 'response', responseType: 'arraybuffer'}).subscribe({
      next: response => {
        const filename = 'userList_' + this.formatToday() + '.csv';
        const blob = new Blob([response.body]);
        saveAs(blob, filename);
        this.successDownloadUsersCsv = true;
        this.utilsService.unlockUi();
      }, error: error => {
        this.utilsService.handleErrorWebservice$(error);
      }
    });
  }

  downloadAllAuthorizations() {
    this.utilsService.lockUi();
    this.customUserService.downloadAllAuthorizations().subscribe({
      next: response => {
        const byteCharacters = atob(response.file_content);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const blob = new Blob([new Uint8Array(byteNumbers)], {type: response.mime_type});
        saveAs(blob, response.file_name);
        this.utilsService.unlockUi();
      }, error: error => {
        this.utilsService.handleErrorWebservice$(error);
      }
    });
  }

  syncWithSalesforce() {
    this.syncButtonDisabled = true;
    this.syncError = false;
    this.successSync = false;
    this.syncIsRunning = false;
    this.syncIsDisabled = false;
    this.customCompanyService.syncWithSalesforce().subscribe({
        next: res => {
          /* CASE SYNC WITH ERROR */
          if (res['status'] === 'sync-error') {
            this.successSync = false;
            this.syncError = true;
            this.syncButtonDisabled = false;
            if (res['message'] === 'Syncing is disabled.') {
              this.syncIsDisabled = true;
              this.automaticSync = false;
              this.syncIsRunning = false;

            } else if (res['message'] === 'Syncing is already running.') {
              this.syncIsRunning = true;
              this.syncIsDisabled = false;
              this.automaticSync = false;

            }
          } else if (res['message'] === 'sync done with success') {
            /* CASE SYNC IS DONE */
            this.syncError = false;
            this.successSync = true;
            this.syncButtonDisabled = false;
          } else if (res['message'] === 'automatic syncing has stopped') {
            /* case where the last job was stopped with error */
            this.syncError = true;
            this.automaticSync = true;
            this.syncButtonDisabled = false;
            this.successSync = true;
          }
        }, error: error => {
          this.syncError = true;
          if (error.status === 'error') {
            this.error = true;
            this.errorMessage = error.message;
          }
        }
      }
    );
  }

  private loadListClients() {
    this.utilsService.lockUi();
    forkJoin([
      this.companyService.getCompanyCollection(),
      this.customCompanyService.getClientsLoasSchedules()
    ]).subscribe(
      ([response, clientsLoasSchedules]) => {
        response = _.sortBy(response, 'name');
        this.listClients = response;
        this.filter();
        this.utilsService.unlockUi();
        this.loading = false;
        this.listClients.forEach(client => {
          if (clientsLoasSchedules.loasClients.includes(client.sugarUuid)) {
            client.hasLoa = true;
          }
          if (clientsLoasSchedules.schedulesClients.includes(client.sugarUuid)) {
            client.hasSchedule = true;
          }
          if (client.label === 4) {
            client.name += ' (Vendor)';
          }
        });
        this.loadUsersInfos();
      }
    );
  }

  private loadUsersInfos() {
    this.customCompanyService.loadUsersInfos().subscribe(
      res => {
        for (const client of this.listClients) {
          if (!res[client.id]) {
            continue;
          }
          client.usersInfos = res[client.id]['usersInfos'];
          client.activeUsers = res[client.id]['activeUsers'];
          client.totalUsers = res[client.id]['totalUsers'];
          client.lastLogin = res[client.id]['lastLogin'];
        }
        this.filter();
      }
    );
  }

  private deactivate(client) {
    // deactivating the aws access before deactivating the client.
    this.deactivateAwsAccess(client);
    return this.companyService.deactivateClient(client.id).subscribe({
        next: () => {
          this.successDeactivateCompany = true;
          client['isActive'] = false;
          if (this.clientSearchCriteria.status !== 'all') {
            this.filteredListClients.splice(this.filteredListClients.indexOf(client), 1);
          }
        },
        error: () => {
          this.error = true;
        }
      }
    );
  }

  private activate(client) {
    return this.companyService.activateClient(client.id).subscribe({
        next: () => {
          this.successActivateCompany = true;
          client['isActive'] = true;
          if (this.clientSearchCriteria.status !== 'all') {
            this.filteredListClients.splice(this.filteredListClients.indexOf(client), 1);
          }
        },
        error: () => {
          this.error = true;
        }
      }
    );
  }

  private formatToday(): string {
    const today = new Date();
    return today.toISOString().substr(0, 19);
  }
}

